<template>
  <h1>New Booking</h1>
</template>

<script>
export default {};
</script>

<style></style>
